import { ContentType } from '@entries/content-types'
import ContentfulContentArticle from '@entries/contentful-content-article'
import ContentfulFaqPageList from '@entries/contentful-faq-page-list'
import ContentfulReview from '@entries/contentful-review'
import ContentfulWrapperRichMedia from '@entries/contentful-wrapper-rich-media'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import clsx from 'clsx'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulPageSectionBento: Utils.EntryFC<
  Queries.ContentfulPageSectionBentoFragment
> = ({
  content: { contents = [] },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div className="flex justify-center">
    <div
      className={clsx(
        'grid grid-cols-1 gap-6 tablet:max-w-[976px] tablet:grid-cols-2',
        {
          'tablet:mb-[4rem]': contents?.length % 2 === 0,
        }
      )}
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'contents',
      })}
    >
      {contents?.map((item: any, i: number) => (
        <div
          key={i}
          className={clsx('relative flex w-full items-stretch', {
            'laptop:top-[5rem]': i % 2 !== 0,
          })}
        >
          <Entry
            content={item}
            mapping={{
              [ContentType.ContentfulContentArticle]: ContentfulContentArticle,
              [ContentType.ContentfulWrapperRichMedia]:
                ContentfulWrapperRichMedia,
              [ContentType.ContentfulReview]: ContentfulReview,
              [ContentType.ContentfulFaqPageList]: ContentfulFaqPageList,
            }}
          />
        </div>
      ))}
    </div>
  </div>
)

export const query = graphql`
  fragment ContentfulPageSectionBento on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentfulContentArticle
      ...ContentfulWrapperRichMedia
      ...ContentfulReview
      ...ContentfulFaqPageList
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionBento,
  'ContentfulPageSectionBento'
)
